
const DollarIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <g clipPath="url(#clip0_135_6520)">
                <path d="M7.00033 12.8334C10.222 12.8334 12.8337 10.2217 12.8337 7.00008C12.8337 3.77842 10.222 1.16675 7.00033 1.16675C3.77866 1.16675 1.16699 3.77842 1.16699 7.00008C1.16699 10.2217 3.77866 12.8334 7.00033 12.8334Z" stroke="#667085" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M9.33366 4.66675H5.83366C5.52424 4.66675 5.22749 4.78966 5.0087 5.00846C4.78991 5.22725 4.66699 5.524 4.66699 5.83341C4.66699 6.14283 4.78991 6.43958 5.0087 6.65837C5.22749 6.87716 5.52424 7.00008 5.83366 7.00008H8.16699C8.47641 7.00008 8.77316 7.123 8.99195 7.34179C9.21074 7.56058 9.33366 7.85733 9.33366 8.16675C9.33366 8.47617 9.21074 8.77291 8.99195 8.99171C8.77316 9.2105 8.47641 9.33341 8.16699 9.33341H4.66699" stroke="#667085" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M7 10.5V3.5" stroke="#667085" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_135_6520">
                    <rect width="14" height="14" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default DollarIcon